import { NgOptimizedImage } from '@angular/common';
import { Component, input } from '@angular/core';
import { CampaignPhase } from '@shared/constants';
import { ElementDirective, TooltipDirective } from '@shared/directives';
import { StepChallenge } from '@shared/factory';
import { StepChallengeVariant6Config } from '@shared/models';
import { AmountPipe } from '@shared/pipes';

import {
  SelectionButtonComponent,
  UnselectionButtonComponent,
  WinCardComponent,
} from '../../elements';
import { StepBaseClass } from '../step.base.class';

import { ProgressSectionComponent } from './progress-section/progress-section.component';

@Component({
  selector: 'b2c-variant6',
  styleUrl: './variant6.component.scss',
  templateUrl: './variant6.component.html',
  imports: [
    AmountPipe,
    NgOptimizedImage,
    WinCardComponent,
    ElementDirective,
    TooltipDirective,
    ProgressSectionComponent,
    SelectionButtonComponent,
    UnselectionButtonComponent,
  ],
})
export class Variant6Component extends StepBaseClass {
  challenge = input.required<StepChallenge>();
  config = input.required<StepChallengeVariant6Config>();

  index = input<number>(0);
  loadBannerInPriority = input<boolean>(false);
  isBisCampaign = input<boolean>(false);
  isEventChallenge = input<boolean>(false);
  withShadow = input<boolean>(true);
  phase = input<CampaignPhase>(CampaignPhase.CURRENT);
}
